module.exports = "/fonts/vendor/@mdi/materialdesignicons-webfont.woff2?11e44ec7bb075f6083ac8d895c711704";